<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          icon="ShoppingBagIcon"
          :statistic="cardData.analyticsData.orders"
          statisticTitle="Orders Received"
          :chartData="cardData.series"
          color="warning"
          type="area"
        >
        </statistics-card-line>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          icon="UsersIcon"
          :statistic="cardData.analyticsData.orders"
          statisticTitle="Subscribers Gained"
          :chartData="cardData.series"
          color="danger"
          type="area"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          icon="ShoppingBagIcon"
          :statistic="cardData.analyticsData.orders"
          statisticTitle="Orders Received"
          :chartData="cardData.series"
          color="primary"
          type="area"
        >
        </statistics-card-line>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          icon="ShoppingBagIcon"
          :statistic="cardData.analyticsData.orders"
          statisticTitle="Orders Received"
          :chartData="cardData.series"
          color="success"
          type="area"
        >
        </statistics-card-line>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
// import StatisticsCardLine from '../../components/statistics-cards/StatisticsCardLine.vue';

export default {
  name: "AdminDashboard",
  data: () => ({
    cardData: {
      series: [
        {
          name: "Orders",
          data: [10, 15, 8, 15, 7, 12, 8]
        }
      ],
      analyticsData: {
        orders: 97500
      }
    }
  }),
  components: {
    StatisticsCardLine
    // StatisticsCardLine
  }
};
</script>
